import { ReactElement } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/joy";
import { theme } from "styles/theme";
import CustomTypography from "../../../common/CustomTypography";

export default function AccordionTemplate({
  summary,
  details,
  noBorder,
}: {
  summary: string;
  details: (string | ReactElement) | (string | ReactElement)[];
  noBorder?: boolean;
}) {
  return (
    <Accordion
      sx={{
        px: "0px",
        py: "10px",
        ...(noBorder && { borderBottomWidth: "0px" }),
      }}
    >
      <AccordionSummary
        sx={{
          p: 0,
          m: 0,
        }}
      >
        <CustomTypography
          variant={"Subtitle"}
          sx={{
            fontWeight: 700,
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {summary}
        </CustomTypography>
      </AccordionSummary>
      <AccordionDetails>
        <CustomTypography
          variant={"Body"}
          sx={{
            pt: 3,
            pb: "14px",
            fontWeight: 500,
            color: theme.vars.palette.Content.Strong,
          }}
        >
          {details}
        </CustomTypography>
      </AccordionDetails>
    </Accordion>
  );
}